<template>
<div>
  <el-dialog
    title="新增病种"
    :visible.sync="isShow"
    width="890px"
    @close="close"
    :close-on-click-modal="false">
    <div style="background: white; padding: 16px;">
      <el-form ref="formRef" :model="formData" :rules="rules" :inline="true">
        <el-row>
          <el-form-item label="救助医院" prop="hospitalId">
            <HospitalSelect v-model="formData.hospitalId" @change="hospitalChange" :disabled="true"></HospitalSelect>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="病种" prop="diseasesIdList">
              <DiseaseCascader v-model="formData.diseasesIdList" :hospitalId="formData.hospitalId" :multiple="true" @change="diseaseChange"></DiseaseCascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单次/分期" prop="quotaType">
              <el-radio-group v-model="formData.quotaType" @change="quotaChange" :disabled="disabledQuotaType || isAllowStages==0">
                <el-radio :label="0">单次</el-radio>
                <el-radio :label="1">分期</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期数"  style="position: relative">
              <el-input v-if="isAngleDiseases" type="text" :disabled="true" value="-" size="small" />
              <el-input v-else type="text" :disabled="true" v-model="formData.totalStages" size="small" />
              <div  v-if="!isAngleDiseases&&formData.quotaType==1" class="error">
                <img src="/static/err-icon.png" alt="">
                <span>如需修改期数，请联系项目人员！</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="申请方式" prop="reqMode">
            <el-radio-group v-model="formData.reqMode">
              <el-radio label="2">代申请</el-radio>
              <el-radio label="1">家长申请</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row v-if="formData.reqMode" style="margin-top: -20px;">
          <el-form-item label=" ">
            <span style="font-size: 12px; color: red;">新增病种后，请到{{formData.reqMode == 2 ? '患儿代申请' : '患儿注册'}}功能完善信息并提交申请。</span>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button :loading="loading" @click="close">取消</el-button>
      <el-button :loading="loading" type="primary" @click="saveChildDiseases">确定</el-button>
    </div>
  </el-dialog>



  <msgDialog :showErrorIcon="true" title="提示"  width="450px" @close="close" :visible.sync="visibleCheckDiseases">
    <div style="margin: auto;width: 95%">
        <span style="font-weight: bold;font-size: 16px;line-height: 20px">当前患儿已存在<span style="color: #E8556F">{{DiseasesName}}</span>病种<span  style="color: #E8556F"></span>，
        <span>
          且状态为<span style="color: #E8556F">{{apprStatus}}</span>，
        </span>
        <span>
          无法新增病种，请和项目人员联系。
        </span>
      </span>
    </div>
    <div slot="footer" >
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="close">确 定</el-button>
    </div>
  </msgDialog>

</div>

</template>

<script>
import { saveChildDiseasesFromManage,
  saveChildDiseasesFromManageD,
  checkDiseasesRepeat
} from "@/util/api";
import HospitalSelect from "@/components/business/HospitalSelect";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import MsgCodeInput from "@/components/business/MsgCodeInput";
import msgDialog from "@/components/business/msgDialog";

export default {
  components: {
    HospitalSelect,
    DiseaseCascader,
    DictionarySelect,
    MsgCodeInput,
    msgDialog
  },
  props: {
    visible: false,
    childUid: String,
    hospitalId: String,
    info:{}
  },
  watch: {
    visible() {
      this.isShow = this.visible;
    },
  },
  data () {
    let isHospitalRole = this.isHospital();
    return{
      isHospitalRole: isHospitalRole,
      loading: false,
      isShow:this.visible,
      disabledQuotaType: false,
      initialProject: null,
      formData: {
        quotaType: null,
        reqMode: null,
        diseasesType: null,
        hospitalId: null,
        diseasesIdList: null
      },
      rules: {
        hospitalId: [{
          required: true,
          message: '请选择医院',
          trigger: 'change'
        }],
        diseasesIdList: [{
          required:true,
          message: '请选择病种',
          trigger: 'change'
        }],
        quotaType: [{
          required:  (this.isAngleDiseases||this.isAllowStages!=0),
          message: '请选择单次/分期',
          trigger: 'change'
        }],
        reqMode: [{
          required: true,
          message: '请选择是否代申请',
          trigger: 'change'
        }],
      },
      isAllowStages: 0,
      msgCodeValue: null,
      isAngleDiseases: false,
      visibleCheckDiseases:false,
      apprStatus:null,
      DiseasesName:null,
      reqMode:null
    }
  },
  mounted () {
    this.formData.hospitalId = this.hospitalId;
    this.$set(this.formData, 'hospitalId', this.hospitalId);
    this.$forceUpdate()
  },
  methods: {
    quotaChange () {
      this.formData.totalStages = this.formData.quotaType == 1 ? 3 : 1;
      this.$forceUpdate()
    },
    hospitalChange (id, obj) {
      this.isAllowStages = obj.isAllowStages;
      if (this.isAllowStages == 0) {
        this.$set(this.formData, 'quotaType', 0);
      }
    },
    diseaseChange (val, isBoby, isAngle, initialProject) {
      if (val && val.length > 0) {
        this.isBobyDiseases = isBoby;
        this.isAngleDiseases = isAngle;
        this.initialProject = initialProject;
        if (this.isBobyDiseases) {
            this.formData.loginChannel = '2';
          } else {
            this.formData.loginChannel = '1';
          }
        this.disabledQuotaType = this.isAllowStages == 0 || initialProject != 'AY1001';
        if (this.disabledQuotaType) {
          this.$set(this.formData, 'quotaType', this.isAngleDiseases ? 1 : 0);
          this.quotaChange(this.formData.quotaType);
        }
      } else {
        this.$set(this.formData, 'quotaType', null);
        this.formData.totalStages = null;
        this.formData.curStages = null;
        this.isBobyDiseases = null;
        this.isAngleDiseases = null;
        this.initialProject = null;
      }

      this.$emit('diseaseChange', val, isBoby, isAngle, initialProject);
      return;
    },
    saveChildDiseases() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.formData.diseasesList = this.formData.diseasesIdList.map(d => {
            return {
              diseasesId: d
            }
          });
          let params = {
            ...this.formData,
            childUid: this.childUid,
            publishStatus: 2
          }
          checkDiseasesRepeat(params).then((res) => {
            debugger;
             if(res.msgCode==200 && res.responseData.checkDiseases==true){
               this.visibleCheckDiseases=true;
               this.apprStatus=res.responseData.apprStatus;
               this.DiseasesName=res.responseData.DiseasesName;
               this.reqMode=res.responseData.reqMode;
             }else {
               if (params.reqMode == '1') {
                 saveChildDiseasesFromManage(params).then((res) => {
                   this.loading = false;
                   if (res.msgCode == 200) {
                     this.$emit('success', params);
                     this.$emit('close')
                   } else {
                     this.$message.error(res.msg);
                   }
                 });
               } else {
                 saveChildDiseasesFromManageD(params).then((res) => {
                   this.loading = false;
                   if (res.msgCode == 200) {
                     this.$emit('success', params);
                     this.$emit('close')
                   } else {
                     this.$message.error(res.msg);
                   }
                 });
               }
             }
          });


        }
      });
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/manage/ChildDiseasesAdd.vue